module.exports = __webpack_public_path__ + "img/game-box.2004b9c8.png";